/** @jsxImportSource @emotion/react */
import React from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  // Badge,
  Button,
  IconButton,
  Toolbar,
  useTheme,
} from '@mui/material';
import InputIcon from '@mui/icons-material/Input';
import MenuIcon from '@mui/icons-material/Menu';

// import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import Logo from '../../../../assets/logos/new-logo.png';
import { selectUser } from '../../../../store/reducers';
import { GtHidden } from '../../../../components/temp-custom-ui-components';
import { useStyles } from './TopBar.styles';

type TopBarProps = {
  className?: string;
  onSidebarOpen: () => void;
  onSignOut: () => void;
};

export function TopBar(props: TopBarProps): React.ReactElement {
  const { className, onSidebarOpen, onSignOut } = props;

  const theme = useTheme();
  const styles = useStyles(theme);
  const user = useSelector(selectUser);

  // const [notifications] = useState([]);

  return (
    <AppBar css={styles} className={className} data-test-id="main-top-bar">
      <Toolbar data-test-id="main-top-bar-container">
        <RouterLink className="link" to="/">
          <img
            className="logo"
            alt="Gaytaro"
            src={Logo}
            data-test-id="main-logo"
          />
        </RouterLink>
        <div className="flex-grow" data-test-id="app-bar-buttons">
          {/* <AccessGuard resourceType={RBACResourceType.Company} roleAccessTypes={RBACRoleTypes.list}> */}
          {/*  <LinkButton data-test-id="top-bar-companies-button" href={webAppRoutes.dashboard} className="page-button"> */}
          {/*    Companies */}
          {/*  </LinkButton> */}
          {/* </AccessGuard> */}
        </div>
        <GtHidden smDown>
          {/*<IconButton color="inherit" size="large">*/}
          {/*  <Badge*/}
          {/*    badgeContent={notifications.length}*/}
          {/*    color="primary"*/}
          {/*    variant="dot"*/}
          {/*  >*/}
          {/*    <NotificationsIcon />*/}
          {/*  </Badge>*/}
          {/*</IconButton>*/}
          <IconButton
            className="sign-out-button"
            color="inherit"
            onClick={onSignOut}
            data-test-id="sign-off-button"
            size="large"
          >
            <InputIcon />
          </IconButton>
        </GtHidden>
        <GtHidden mdUp>
          <IconButton color="inherit" onClick={onSidebarOpen} size="large">
            <MenuIcon />
          </IconButton>
        </GtHidden>
        <GtHidden smDown>
          {user && (
            <Button disabled={!user} className="header-button">
              {user.name}
            </Button>
          )}
        </GtHidden>
      </Toolbar>
    </AppBar>
  );
}
